module.exports = __webpack_public_path__ + "img/Icon-17.2f0e97fb.png";